import { render, staticRenderFns } from "./ItemViews.vue?vue&type=template&id=0240257a&scoped=true&"
import script from "./ItemViews.vue?vue&type=script&lang=js&"
export * from "./ItemViews.vue?vue&type=script&lang=js&"
import style0 from "./ItemViews.vue?vue&type=style&index=0&id=0240257a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0240257a",
  null
  
)

export default component.exports